<template>
  <div class="container-fluid centered col-md-6">
    <b-card>
      <b-card-body>
        <!--<label> Sie müssen <a href="/">eingeloggt</a> sein, um diese Seite zu sehen! </label>-->
        <label> Sie müssen <label class="redirect" @click="redirectToLogin">eingeloggt</label> sein, um diese Seite zu sehen! </label>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'NotLoggedIn',
  methods: {
    redirectToLogin () {
      this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
    }
  }
}
</script>

<style>
.redirect {
  color: #337ab7 !important;
}
.redirect:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/NotLoggedIn.vue